import React from 'react';

import { BigFormActionButtonProps } from './BigFormActionButton.interface';
import { useStyles } from './BigFormActionButton.styles';
import { NewButton } from 'app/components/NewButton';

export default function BigFormActionButton(props: BigFormActionButtonProps) {
  const { type = 'submit' } = props;
  const classes = useStyles();

  return (
    <NewButton
      variant={'contained'}
      color={'primary'}
      size={'large'}
      type={type}
      classes={{
        root: classes.button,
        contained: classes.contained,
        disabled: classes.disabled,
      }}
      {...props}
    />
  );
}
